import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { TextPlugin } from "gsap/TextPlugin.js";

gsap.registerPlugin(TextPlugin, ScrollToPlugin);

import horizontalLoop from "./_horizontal-loop.mjs";

import { Gradient } from "whatamesh";

export default function initService26Hero() {
  const hero_title = document.querySelector(".service-twentysix-hero__title");
  const hero_title_replacable = document.querySelector(
    ".service-twentysix-hero__title > span",
  );
  let hero_title_replacement_texts;
  let hero_title_timeline = gsap.timeline({ repeat: -1 });
  const go_to_service_links = document.querySelectorAll(".go-to-service");
  const logos = gsap.utils.toArray(".service-twentysix-hero__logo-cell");

  if (go_to_service_links) {
    go_to_service_links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = link.dataset.target;
        gsap.to(window, { scrollTo: { y: target, offsetY: 120 }, duration: 1 });
      });
    });
  }

  if (logos) {
    horizontalLoop(logos, { speed: 0.8, repeat: -1 });
  }

  if (document.querySelector(".service-twentysix-hero__form-container")) {
    const gradient_twentysix = new Gradient();
    gradient_twentysix.initGradient("#gradient-canvas");
  }

  if (hero_title && hero_title_replacable) {
    if (
      hero_title.dataset.animatedText ||
      hero_title.dataset.animatedText !== ""
    ) {
      hero_title_replacement_texts = JSON.parse(
        hero_title.dataset.animatedText,
      );
      if (hero_title_replacement_texts.length > 1) {
        hero_title_replacement_texts.push(hero_title_replacable.textContent);
        hero_title_replacement_texts.forEach((text) => {
          hero_title_timeline.to(
            hero_title_replacable,
            {
              text: {
                value: text,
                padSpace: true,
                preserveSpaces: true,
              },
              duration: 1,
              ease: "none",
            },
            ">1.5",
          );
        });
      }
    }
  }
}
